import { ConciergeListContext } from '@context/ConciergeListContext'
import { useContext } from 'react'

export function useConciergeList() {
  const context = useContext(ConciergeListContext)
  if (!context) {
    throw new Error(
      'useConciergeList must be used within a ConciergeListProvider',
    )
  }
  return context
}
